import {
  defineSchema,
  type SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import {
  RECOGNIZE_VIP_CONDITIONS,
  vipCriterionLabel,
} from "@redotech/redo-recognize-common/criteria";
import { objectEntries, objectMapValues } from "@redotech/util/object";

export const recognizeSchema = defineSchema({
  fields: {
    isVip: {
      dataType: "Boolean",
      label: "VIP",
      documentation: "Whether the customer matched at least one VIP criterion.",
    },
    ...objectMapValues(RECOGNIZE_VIP_CONDITIONS, (criterion) => ({
      dataType: "Boolean" as const,
      label: vipCriterionLabel(criterion),
      documentation: `Whether the customer matched the ${vipCriterionLabel(criterion)} VIP category.`,
    })),
  },
});

export const recognizeConditionFields = objectEntries(
  recognizeSchema.fields,
).map(([field]) => field);

export type RecognizeConditionField = keyof typeof recognizeSchema.fields;

export const exampleRecognizeInstance: SchemaInstance<typeof recognizeSchema> =
  {
    ...objectMapValues(RECOGNIZE_VIP_CONDITIONS, () => false),
    isVip: true,
    investorOrWealthManager: true,
  };
